import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
export default function BeginYourTransformation() {
  return <section data-section-id="229856" id="ready-for-a-transformation" className="dark bg-background text-foreground py-24 sm:py-32 px-4 sm:px-6 lg:px-8 flex items-center justify-center">
      <div className="w-full max-w-5xl border border-border/10 p-12 sm:p-16 md:p-24 flex flex-col items-center justify-center text-center relative overflow-hidden rounded-lg shadow-xl">
        {}
        <div className="absolute inset-0 bg-gradient-to-br from-primary/20 via-transparent to-transparent pointer-events-none" />
        
        <h2 className="font-default text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-light tracking-wide text-foreground max-w-3xl leading-tight relative z-10">
          Ready for a Transformation?
        </h2>
        
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-6 mt-12 relative z-10">
          <Button asChild size="lg" className="w-full sm:w-auto px-8 h-12 text-base font-default tracking-wide bg-primary text-primary-foreground hover:opacity-90 transition-opacity rounded-lg">
            <Link to="/GetAQuotePage">
              Book Your Free Consultation
            </Link>
          </Button>
          
          <Button asChild variant="ghost" size="lg" className="w-full sm:w-auto px-8 h-12 text-base font-default tracking-wide hover:bg-accent/10 text-foreground rounded-lg">
            <Link to="/OurCraftPage">
              Explore Our Craft
            </Link>
          </Button>
        </div>
      </div>
    </section>;
}